import { render, staticRenderFns } from "./effect-factory.vue?vue&type=template&id=7c085fb0&scoped=true"
import script from "./effect-factory.vue?vue&type=script&lang=js"
export * from "./effect-factory.vue?vue&type=script&lang=js"
import style0 from "./effect-factory.vue?vue&type=style&index=0&id=7c085fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c085fb0",
  null
  
)

export default component.exports